export const rewardCategory = {
  loyaltyCategory: "Loyalty Category",
  rewardCategory: "Reward Category",
  search: "Search",
  createCategory: "Create Category",
  name: "Name",
  cagoryName: "Category Bane",
  image: "Image",
  clickToUpload: "Click to Upload",
  active: "Active",
  isActive: "IsActive",
  previewImage: "Preview Image",
  edit: "Edit",
  upload: "Upload",
  close: "close",
  submit: "submit",
  id: "Id",
  dateCreated: "Date Created",
  editCategory: "Edit Category",
  active: "Active",
  categoryName: "Category Name",
  type: "Type",
  description:"Description",
  descriptionName:"Description"
};
